// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shop {
  display: flex;
  flex-direction: row;
  position: relative;
  filter: blur(100px);
  position: relative;
  animation: blurry 2s ease-in-out forwards;
  gap: 1em;
  font-family: "Varela Round";
}
.shop_store {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1em;
  overflow-y: scroll;
  margin-top: 5em;
  animation: fadeIn 0.3s ease-in-out forwards;
  transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);
}
.shop_store_item {
  width: 38em;
  height: 25em;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.shop_store_item_product {
  margin: 0.5em 1em;
  width: 38em;
  height: 25em;
  background-color: #1c1c1c;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}
.shop_store_item_product_img {
  transition: all 1s ease-in-out;
  width: 32em;
  height: 20em;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.shop_store_item_product:hover > .shop_store_item_product_img {
  transition: all 0.3s ease-in-out;
  transform: scale(1.1);
}
.shop_store_item_info {
  display: flex;
  flex-direction: row;
  gap: 4em;
  color: white;
  justify-content: center;
  align-items: center;
}
.shop_store_item_info_name_bottom {
  font-size: 0.5em;
  color: #88888a;
}
.shop_store_item_info_desc {
  font-size: 0.8em;
  color: #88888a;
}
.shop_store_item_info_price {
  font-size: 0.8em;
  color: #88888a;
}
.shop_modals {
  display: flex;
  flex-direction: row;
  gap: 1em;
  overflow-y: scroll;
  flex-wrap: wrap;
  margin-top: 5em;
  animation: fadeIn 0.3s ease-in-out forwards;
}
.shop_modals_item {
  width: 38em;
  height: 35em;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.shop_modals_item_product {
  margin: 0.5em 1em;
  width: 38em;
  height: 35em;
  background-color: #1c1c1c;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
}
.shop_modals_item_product_img {
  transition: all 1s ease-in-out;
  width: 32em;
  height: 40em;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.shop_modals_item_product:hover > .shop_modals_item_product_img {
  transition: all 1s ease-in-out;
}
.shop_modals_item_info {
  display: flex;
  flex-direction: row;
  gap: 4em;
  color: white;
  justify-content: center;
  align-items: center;
}
.shop_modals_item_info_name_top {
  display: inline-block;
  font-family: "Varela Round";
  font-size: 1em;
  letter-spacing: 5px;
  color: #88888a;
  text-transform: uppercase;
}
.shop_modals_item_info_name_bottom {
  font-size: 0.5em;
  color: #88888a;
}
.shop_modals_item_info_desc {
  font-size: 0.8em;
  color: #88888a;
}
.shop_modals_item_info_price {
  font-size: 0.8em;
  color: #88888a;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.overlay-shop-menu {
  display: flex;
  flex-direction: column;
  gap: 2em;
  width: 25%;
  height: 50em;
  opacity: 1;
  position: relative;
  background-image: linear-gradient(to top, #000000, #220a0f, #3a0b15, #540616, #6d0012, #841511, #9a290c, #af3e00, #c76000, #dd8200, #f0a500, #ffc917);
  z-index: 5;
}
.overlay-shop-menu_title {
  margin-top: 10em;
}
.overlay-shop-menu_subtitle {
  font-family: "Varela Round";
  font-size: 11px;
  letter-spacing: 5px;
  line-height: 2em;
  color: white;
  text-transform: uppercase;
  position: relative;
  padding: 1em 4em;
}
.overlay-shop-menu_shirts {
  cursor: pointer;
  position: relative;
  top: 20%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-shop-menu_shirts_img {
  width: 4em;
  height: 4em;
}
.overlay-shop-menu_shirts_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-shop-menu_shirts_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-shop-menu_shirts_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-shop-menu_shirts:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-shop-menu_shirts:hover_title_top {
  color: black;
}
.overlay-shop-menu_tattoo-care {
  cursor: pointer;
  position: relative;
  top: 22%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-shop-menu_tattoo-care_img {
  width: 4em;
  height: 4em;
}
.overlay-shop-menu_tattoo-care_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-shop-menu_tattoo-care_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-shop-menu_tattoo-care_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-shop-menu_tattoo-care:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-shop-menu_tattoo-care:hover_title_top {
  color: black;
}
.overlay-shop-menu_jewelry {
  cursor: pointer;
  position: relative;
  top: 24%;
  padding: 0.2em 0.3em;
  border: 1px solid rgb(136, 136, 138);
  border-radius: 5px;
  opacity: 1;
  margin: 0 2em;
  display: flex;
  flex-direction: row;
  width: 19em;
}
.overlay-shop-menu_jewelry_img {
  width: 4em;
  height: 4em;
  border-radius: 4px;
  overflow: hidden;
}
.overlay-shop-menu_jewelry_title {
  font-family: "Varela Round";
  font-size: 1.5em;
  letter-spacing: 0px;
}
.overlay-shop-menu_jewelry_title_top {
  font-size: 0.8em;
  height: 0.3em;
  padding: 0.6em 0;
  display: block;
  color: white;
}
.overlay-shop-menu_jewelry_title_bottom {
  font-size: 0.3em;
  color: #88888a;
}
.overlay-shop-menu_jewelry:hover {
  background-color: rgba(243, 243, 243, 0.2);
}
.overlay-shop-menu_jewelry:hover_title_top {
  color: black;
}

.back-icon {
  width: 3em;
  height: 3em;
  color: #f00000;
}

img {
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
  image-rendering: auto;
}

.shop_video {
  height: 35em;
}

.shop_img {
  width: 100%;
  height: 35em;
}

@keyframes blurry {
  0% {
    filter: blur(100px);
  }
  100% {
    filter: blur(0px);
  }
}
@keyframes flickerL {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  100% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
}
@keyframes flickerO {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.66667% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  73.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  74% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  74.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  75.33333% {
    color: rgba(255, 255, 255, 0.7);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white, 0 0 40px white;
  }
  75.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  94.44444% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
@keyframes flickerA {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.86667% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  88.88889% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerD {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.31111% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  83.33333% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerI {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.75556% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  77.77778% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerN {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.2% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  72.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
}
@keyframes flickerG {
  0% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  22.22222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  24% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  24.02222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  25.8% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  25.82222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  27.6% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  27.62222% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  29.4% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.64444% {
    color: rgba(255, 255, 255, 0.26);
    -webkit-text-stroke-color: white;
    text-shadow: 0 0 80px white, 0 0 40px white;
  }
  66.66667% {
    color: black;
    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);
    text-shadow: none;
  }
  100% {
    color: black;
    -webkit-text-stroke-color: rgb(240, 0, 0);
    text-shadow: none;
  }
}
#d-mobile li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.4vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: #f3f3f3;
}

#d {
  position: absolute;
  top: 20%;
  left: 0%;
  height: 5vw;
  width: 40%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#d li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#d li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#d li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#d li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#d li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#d li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

#d li:nth-child(6) {
  animation-name: flickerN;
  animation-delay: 1.25s;
  animation-duration: 4.5s;
}

#d li:nth-child(7) {
  animation-name: flickerG;
  animation-delay: 1.5s;
  animation-duration: 4.5s;
}

#s {
  position: absolute;
  top: 20%;
  left: 30%;
  height: 5vw;
  width: 40%;
  transform: translateY(-50%);
  margin: 0 auto;
  text-align: center;
  z-index: 8;
}

#s li {
  display: inline-block;
  position: relative;
  height: 5vw;
  list-style: none;
  font-family: "Varela Round";
  font-weight: bolder;
  font-size: 1.5vw;
  color: black;
  -webkit-text-stroke-width: 0.045vw;
  -webkit-text-stroke-color: rgb(240, 0, 0);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

#s li:nth-child(1) {
  animation-name: flickerL;
  animation-delay: 0s;
  animation-duration: 4.5s;
}

#s li:nth-child(2) {
  animation-name: flickerO;
  animation-delay: 0.25s;
  animation-duration: 4.5s;
}

#s li:nth-child(3) {
  animation-name: flickerA;
  animation-delay: 0.5s;
  animation-duration: 4.5s;
}

#s li:nth-child(4) {
  animation-name: flickerD;
  animation-delay: 0.75s;
  animation-duration: 4.5s;
}

#s li:nth-child(5) {
  animation-name: flickerI;
  animation-delay: 1s;
  animation-duration: 4.5s;
}

.buy-button {
  position: relative;
  border-width: 0;
  color: white;
  font-size: 15px;
  font-weight: 600;
  border-radius: 4px;
  background-color: black;
  z-index: 1;
}

.buy-button .buy-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 40px;
  padding: 0 0.3em;
  border-radius: 4px;
  z-index: 1;
  background-color: rgb(5, 5, 5);
  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
}

.buy-button:hover {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.buy-now {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90%;
  margin: 0 auto;
  z-index: -1;
  color: #050505;
  border-radius: 4px;
  transform: translateY(0%);
  background-color: #ffc917;
  border: solid 1px rgba(1, 224, 87, 0.1764705882);
  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);
}

.buy-button:hover .buy-now {
  transform: translateY(80%);
}

.buy-now svg path,
.buy-now svg line {
  animation: docs 1s infinite;
}

@keyframes docs {
  0% {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(-15%);
  }
  100% {
    transform: translateY(0%);
  }
}
/* Checkbox */
.tabs {
  display: flex;
  position: relative;
  padding: 0.45rem;
  border-radius: 99px;
  color: #ffc917;
}

.tabs * {
  z-index: 2;
}

.container input[type=radio] {
  display: none;
}

.tab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  width: 50px;
  font-size: 0.8rem;
  color: #f3f3f3;
  font-weight: 500;
  border-radius: 99px;
  cursor: pointer;
  transition: color 0.15s ease-in;
}

@media (min-width: 390px) {
  .shop {
    flex-wrap: wrap;
    height: auto;
  }
  .overlay-shop-menu {
    width: 100%;
    height: auto;
  }
  #d,
  #s {
    top: 10%;
  }
  #d li,
  #s li {
    font-size: 1.5em !important;
  }
  .shop_store_item_info {
    gap: 1em;
  }
  .shop_modals_item {
    width: 100%;
  }
  .shop_modals_item_product {
    width: auto;
  }
}
@media (min-width: 768px) {
  .shop {
    flex-wrap: wrap;
    height: auto;
  }
  .overlay-shop-menu {
    width: 100%;
  }
  #d li,
  #s li {
    font-size: 1.5em !important;
  }
  .shop_modals_item {
    width: 100%;
  }
  .shop_modals_item_product {
    width: auto;
  }
}
@media (min-width: 1024px) {
  .shop {
    flex-wrap: nowrap;
    height: 90em;
  }
  .shop_store_item_info {
    gap: 4em;
  }
  .overlay-shop-menu {
    width: 50%;
    height: 50em;
  }
  #d,
  #s {
    top: 20%;
  }
  #d > li,
  #s li {
    font-size: 1.7em !important;
  }
  .shop_modals_item {
    width: 35em;
  }
  .shop_modals_item_product {
    width: 35em;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Shop/Styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yCAAA;EACA,QAAA;EACA,2BAAA;AADF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,mDAAA;AADJ;AAGI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AADN;AAGM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AADR;AAGQ;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;AADV;AAIQ;EACE,gCAAA;EACA,qBAAA;AAFV;AAMM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAUU;EACE,gBAAA;EACA,cAAA;AARZ;AAYQ;EACE,gBAAA;EACA,cAAA;AAVV;AAaQ;EACE,gBAAA;EACA,cAAA;AAXV;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,2CAAA;AAfJ;AAiBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;AAfN;AAiBM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAfR;AAkBQ;EAEE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,2CAAA;AAjBV;AAoBQ;EACE,8BAAA;AAlBV;AAuBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AArBR;AAwBU;EACE,qBAAA;EACA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,cChJD;EDiJC,yBAAA;AAtBZ;AAyBU;EACE,gBAAA;EACA,cAAA;AAvBZ;AA2BQ;EACE,gBAAA;EACA,cAAA;AAzBV;AA4BQ;EACE,gBAAA;EACA,cAAA;AA1BV;;AAiCA;EACE;IACE,UAAA;IACA,2BAAA;EA9BF;EAiCA;IACE,UAAA;IACA,wBAAA;EA/BF;AACF;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,UAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EAMA,qJAAA;EAgBA,UAAA;AArDF;AAuDE;EACE,gBAAA;AArDJ;AAwDE;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EAEA,gBAAA;AAvDJ;AA0DE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAxDJ;AAyDI;EACE,UAAA;EACA,WAAA;AAvDN;AA0DI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AAxDN;AA0DM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAxDR;AA0DM;EACE,gBAAA;EACA,cCnQG;AD2MX;AA4DI;EACE,0CAAA;AA1DN;AA2DM;EACE,YAAA;AAzDR;AA8DE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA5DJ;AA6DI;EACE,UAAA;EACA,WAAA;AA3DN;AA8DI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AA5DN;AA8DM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AA5DR;AA8DM;EACE,gBAAA;EACA,cC9SG;ADkPX;AAgEI;EACE,0CAAA;AA9DN;AA+DM;EACE,YAAA;AA7DR;AAkEE;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oCAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAhEJ;AAiEI;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AA/DN;AAkEI;EACE,2BAAA;EACA,gBAAA;EACA,mBAAA;AAhEN;AAkEM;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;AAhER;AAkEM;EACE,gBAAA;EACA,cC3VG;AD2RX;AAoEI;EACE,0CAAA;AAlEN;AAmEM;EACE,YAAA;AAjER;;AAuEA;EACE,UAAA;EACA,WAAA;EACA,cC9WQ;AD0SV;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;EACA,qBAAA;AArEF;;AAwEA;EACE,YAAA;AArEF;;AAwEA;EACE,WAAA;EACA,YAAA;AArEF;;AAwEA;EACE;IACE,mBAAA;EArEF;EAwEA;IACE,iBAAA;EAtEF;AACF;AAyEA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvEF;EA0EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxEF;EA0EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxEF;EA0EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxEF;EA0EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxEF;EA0EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxEF;EA0EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxEF;EA0EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAxEF;EA0EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxEF;EA0EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAxEF;AACF;AA2EA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAzEF;EA4EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1EF;EA4EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1EF;EA4EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1EF;EA4EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1EF;EA4EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1EF;EA4EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1EF;EA4EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA1EF;EA4EA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA1EF;EA4EA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EA1EF;EA6EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA3EF;EA6EA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EA3EF;EA8EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA5EF;EA8EA;IACE,+BAAA;IACA,gCAAA;IACA,6EAAA;EA5EF;EA+EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA7EF;EA+EA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA7EF;EA+EA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EA7EF;AACF;AAgFA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA9EF;EAiFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/EF;EAiFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/EF;EAiFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/EF;EAiFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/EF;EAiFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/EF;EAiFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/EF;EAiFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/EF;EAiFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/EF;EAiFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EA/EF;EAiFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/EF;EAiFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EA/EF;AACF;AAkFA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAhFF;EAmFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjFF;EAmFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjFF;EAmFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjFF;EAmFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjFF;EAmFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjFF;EAmFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjFF;EAmFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjFF;EAmFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjFF;EAmFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAjFF;EAmFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjFF;EAmFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAjFF;AACF;AAoFA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAlFF;EAqFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnFF;EAqFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnFF;EAqFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnFF;EAqFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnFF;EAqFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnFF;EAqFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnFF;EAqFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnFF;EAqFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnFF;EAqFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAnFF;EAqFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnFF;EAqFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAnFF;AACF;AAsFA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EApFF;EAuFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArFF;EAuFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArFF;EAuFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArFF;EAuFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArFF;EAuFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArFF;EAuFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArFF;EAuFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArFF;EAuFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArFF;EAuFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EArFF;EAuFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArFF;EAuFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EArFF;AACF;AAwFA;EACE;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAtFF;EAyFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvFF;EAyFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvFF;EAyFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvFF;EAyFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvFF;EAyFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvFF;EAyFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvFF;EAyFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvFF;EAyFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvFF;EAyFA;IACE,gCAAA;IACA,gCAAA;IACA,2CAAA;EAvFF;EAyFA;IACE,YAAA;IACA,mDAAA;IACA,iBAAA;EAvFF;EAyFA;IACE,YAAA;IACA,yCAAA;IACA,iBAAA;EAvFF;AACF;AA2FA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,kCCt2BU;AD6wBZ;;AA4FA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EAEA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AA1FF;;AA4FA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AAzFF;;AA2FA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAxFF;;AA0FA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAvFF;;AAyFA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAtFF;;AAwFA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AArFF;;AAuFA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AApFF;;AAsFA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAnFF;;AAqFA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AAlFF;;AAqFA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EAEA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AAnFF;;AAqFA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;EACA,yCAAA;EACA,mCAAA;EACA,6BAAA;AAlFF;;AAoFA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AAjFF;;AAmFA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AAhFF;;AAkFA;EACE,wBAAA;EACA,qBAAA;EACA,wBAAA;AA/EF;;AAiFA;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;AA9EF;;AAgFA;EACE,wBAAA;EACA,mBAAA;EACA,wBAAA;AA7EF;;AAgFA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;AA7EF;;AAgFA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EACA,oDAAA;AA7EF;;AAgFA;EACE,uLAAA;AA7EF;;AAkFA;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,cCpgCU;EDqgCV,kBAAA;EACA,yBAAA;EACA,yBC1gCS;ED2gCT,gDAAA;EACA,oDAAA;AA/EF;;AAkFA;EACE,0BAAA;AA/EF;;AAkFA;;EAEE,2BAAA;AA/EF;;AAkFA;EACE;IACE,yBAAA;EA/EF;EAkFA;IACE,2BAAA;EAhFF;EAmFA;IACE,yBAAA;EAjFF;AACF;AAoFA,aAAA;AAEA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cC7iCS;AD09BX;;AAsFA;EACE,UAAA;AAnFF;;AAsFA;EACE,aAAA;AAnFF;;AAsFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cC1jCU;ED2jCV,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,+BAAA;AAnFF;;AEz+BE;EFgkCA;IACE,eAAA;IACA,YAAA;EAnFF;EAsFA;IACE,WAAA;IACA,YAAA;EApFF;EAuFA;;IAEE,QAAA;EArFF;EAwFA;;IAEE,2BAAA;EAtFF;EAyFA;IACE,QAAA;EAvFF;EA0FA;IACE,WAAA;EAxFF;EA2FA;IACE,WAAA;EAzFF;AACF;AE//BE;EF4lCA;IACE,eAAA;IACA,YAAA;EA1FF;EA6FA;IACE,WAAA;EA3FF;EA8FA;;IAEE,2BAAA;EA5FF;EA+FA;IACE,WAAA;EA7FF;EAgGA;IACE,WAAA;EA9FF;AACF;AE5gCE;EF8mCA;IACE,iBAAA;IACA,YAAA;EA/FF;EAkGA;IACE,QAAA;EAhGF;EAmGA;IACE,UAAA;IACA,YAAA;EAjGF;EAoGA;;IAEE,QAAA;EAlGF;EAqGA;;IAEE,2BAAA;EAnGF;EAsGA;IACE,WAAA;EApGF;EAuGA;IACE,WAAA;EArGF;AACF","sourcesContent":["@import \"../../assets/scss/combined.scss\";\n\n.shop {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  filter: blur(100px);\n  position: relative;\n  animation: blurry 2s ease-in-out forwards;\n  gap: 1em;\n  font-family: \"Varela Round\";\n\n  &_store {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    gap: 1em;\n    overflow-y: scroll;\n    margin-top: 5em;\n    animation: fadeIn 0.3s ease-in-out forwards;\n    transition: all 10s cubic-bezier(0.77, 0, 0.175, 1);\n\n    &_item {\n      width: 38em;\n      height: 25em;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n\n      &_product {\n        margin: 0.5em 1em;\n        width: 38em;\n        height: 25em;\n        background-color: #1c1c1c;\n        border-radius: 6px;\n        border: 1px solid rgba(255, 255, 255, 0.06);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        cursor: pointer;\n\n        &_img {\n          transition: all 1s ease-in-out;\n          width: 32em;\n          height: 20em;\n          border-radius: 6px;\n          border: 1px solid rgba(255, 255, 255, 0.08);\n        }\n\n        &:hover > &_img {\n          transition: all 0.3s ease-in-out;\n          transform: scale(1.1);\n        }\n      }\n\n      &_info {\n        display: flex;\n        flex-direction: row;\n        gap: 4em;\n        color: white;\n        justify-content: center;\n        align-items: center;\n\n        &_name {\n          &_top {\n          }\n\n          &_bottom {\n            font-size: 0.5em;\n            color: #88888a;\n          }\n        }\n\n        &_desc {\n          font-size: 0.8em;\n          color: #88888a;\n        }\n\n        &_price {\n          font-size: 0.8em;\n          color: #88888a;\n        }\n      }\n    }\n  }\n\n  &_modals {\n    display: flex;\n    flex-direction: row;\n    gap: 1em;\n    overflow-y: scroll;\n    flex-wrap: wrap;\n    margin-top: 5em;\n    animation: fadeIn 0.3s ease-in-out forwards;\n\n    &_item {\n      width: 38em;\n      height: 35em;\n      display: flex;\n      flex-direction: column;\n      justify-content: flex-end;\n\n      &_product {\n        margin: 0.5em 1em;\n        width: 38em;\n        height: 35em;\n        background-color: #1c1c1c;\n        border-radius: 6px;\n        border: 1px solid rgba(255, 255, 255, 0.06);\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n        cursor: pointer;\n        // background-color: #ffc917;\n\n        &_img {\n          // background-color: $bdt-black;\n          transition: all 1s ease-in-out;\n          width: 32em;\n          height: 40em;\n          border-radius: 6px;\n          overflow: hidden;\n          border: 1px solid rgba(255, 255, 255, 0.08);\n        }\n\n        &:hover > &_img {\n          transition: all 1s ease-in-out;\n          // transform: scale(1.1);\n        }\n      }\n\n      &_info {\n        display: flex;\n        flex-direction: row;\n        gap: 4em;\n        color: white;\n        justify-content: center;\n        align-items: center;\n\n        &_name {\n          &_top {\n            display: inline-block;\n            font-family: \"Varela Round\";\n            font-size: 1em;\n            letter-spacing: 5px;\n            color: $bdt-gray;\n            text-transform: uppercase;\n          }\n\n          &_bottom {\n            font-size: 0.5em;\n            color: #88888a;\n          }\n        }\n\n        &_desc {\n          font-size: 0.8em;\n          color: #88888a;\n        }\n\n        &_price {\n          font-size: 0.8em;\n          color: #88888a;\n        }\n      }\n    }\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.overlay-shop-menu {\n  display: flex;\n  flex-direction: column;\n  gap: 2em;\n  //   margin-top: 6em;\n  width: 25%;\n  height: 50em;\n  opacity: 1;\n  position: relative;\n \n \n\n\n\n  background-image: linear-gradient(\n    to top,\n    #000000,\n    #220a0f,\n    #3a0b15,\n    #540616,\n    #6d0012,\n    #841511,\n    #9a290c,\n    #af3e00,\n    #c76000,\n    #dd8200,\n    #f0a500,\n    #ffc917\n  );\n\n  z-index: 5;\n\n  &_title {\n    margin-top: 10em;\n  }\n\n  &_subtitle {\n    font-family: \"Varela Round\";\n    font-size: 11px;\n    letter-spacing: 5px;\n    line-height: 2em;\n    color: white;\n    text-transform: uppercase;\n    position: relative;\n    // top: 16%;\n    padding: 1em 4em;\n  }\n\n  &_shirts {\n    cursor: pointer;\n    position: relative;\n    top: 20%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n    &_img {\n      width: 4em;\n      height: 4em;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n\n  &_tattoo-care {\n    cursor: pointer;\n    position: relative;\n    top: 22%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n    &_img {\n      width: 4em;\n      height: 4em;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n\n  &_jewelry {\n    cursor: pointer;\n    position: relative;\n    top: 24%;\n    padding: 0.2em 0.3em;\n    border: 1px solid rgba(136, 136, 138, 1);\n    border-radius: 5px;\n    opacity: 1;\n    margin: 0 2em;\n    display: flex;\n    flex-direction: row;\n    width: 19em;\n    &_img {\n      width: 4em;\n      height: 4em;\n      border-radius: 4px;\n      overflow: hidden;\n    }\n\n    &_title {\n      font-family: \"Varela Round\";\n      font-size: 1.5em;\n      letter-spacing: 0px;\n\n      &_top {\n        font-size: 0.8em;\n        height: 0.3em;\n        padding: 0.6em 0;\n        display: block;\n        color: white;\n      }\n      &_bottom {\n        font-size: 0.3em;\n        color: $bdt-gray;\n      }\n    }\n\n    &:hover {\n      background-color: rgba(243, 243, 243, 0.2);\n      &_title_top {\n        color: black;\n      }\n    }\n  }\n}\n\n.back-icon {\n  width: 3em;\n  height: 3em;\n  color: $bdt-red;\n  // background-color: orange;\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-position: center center;\n  object-fit: cover;\n  image-rendering: auto;\n}\n\n.shop_video {\n  height: 35em;\n}\n\n.shop_img {\n  width: 100%;\n  height: 35em;\n}\n\n@keyframes blurry {\n  0% {\n    filter: blur(100px);\n  }\n\n  100% {\n    filter: blur(0px);\n  }\n}\n\n@keyframes flickerL {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  100% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n    // opacity: 1;\n  }\n}\n@keyframes flickerO {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.66667% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  73.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  74% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  74.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  75.33333% {\n    color: rgba(255, 255, 255, 0.7);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 400px white, 0 0 100px white, 0 0 80px white,\n      0 0 40px white;\n  }\n  75.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  94.44444% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerA {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.86667% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  88.88889% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerD {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.31111% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  83.33333% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerI {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.75556% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  77.77778% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerN {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.2% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  72.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n@keyframes flickerG {\n  0% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n    // opacity: 0;\n  }\n  22.22222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  24% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  24.02222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  25.8% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  25.82222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  27.6% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  27.62222% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  29.4% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.64444% {\n    color: rgba(255, 255, 255, 0.26);\n    -webkit-text-stroke-color: white;\n    text-shadow: 0 0 80px white, 0 0 40px white;\n  }\n  66.66667% {\n    color: black;\n    -webkit-text-stroke-color: rgba(255, 255, 255, 0.5);\n    text-shadow: none;\n  }\n  100% {\n    color: black;\n    -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n    text-shadow: none;\n    // opacity: 1;\n  }\n}\n\n#d-mobile li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.4vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: $bdt-white;\n}\n\n#d {\n  position: absolute;\n  top: 20%;\n  left: 0%;\n  //   right: 0;\n  height: 5vw;\n  width: 40%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#d li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#d li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#d li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#d li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#d li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#d li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n#d li:nth-child(6) {\n  animation-name: flickerN;\n  animation-delay: 1.25s;\n  animation-duration: 4.5s;\n}\n#d li:nth-child(7) {\n  animation-name: flickerG;\n  animation-delay: 1.5s;\n  animation-duration: 4.5s;\n}\n\n#s {\n  position: absolute;\n  top: 20%;\n  left: 30%;\n  // right: 0%;\n  height: 5vw;\n  width: 40%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  text-align: center;\n  z-index: 8;\n}\n#s li {\n  display: inline-block;\n  position: relative;\n  height: 5vw;\n  list-style: none;\n  font-family: \"Varela Round\";\n  font-weight: bolder;\n  font-size: 1.5vw;\n  color: black;\n  -webkit-text-stroke-width: 0.045vw;\n  -webkit-text-stroke-color: rgba(240, 0, 0, 1);\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n#s li:nth-child(1) {\n  animation-name: flickerL;\n  animation-delay: 0s;\n  animation-duration: 4.5s;\n}\n#s li:nth-child(2) {\n  animation-name: flickerO;\n  animation-delay: 0.25s;\n  animation-duration: 4.5s;\n}\n#s li:nth-child(3) {\n  animation-name: flickerA;\n  animation-delay: 0.5s;\n  animation-duration: 4.5s;\n}\n#s li:nth-child(4) {\n  animation-name: flickerD;\n  animation-delay: 0.75s;\n  animation-duration: 4.5s;\n}\n#s li:nth-child(5) {\n  animation-name: flickerI;\n  animation-delay: 1s;\n  animation-duration: 4.5s;\n}\n\n.buy-button {\n  position: relative;\n  border-width: 0;\n  color: white;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 4px;\n  background-color: black;\n  z-index: 1;\n}\n\n.buy-button .buy-icon {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  min-height: 40px;\n  padding: 0 0.3em;\n  border-radius: 4px;\n  z-index: 1;\n  background-color: rgba(5, 5, 5, 1);\n  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.buy-button:hover {\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,\n    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,\n    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;\n}\n\n.buy-now {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 90%;\n  margin: 0 auto;\n  z-index: -1;\n  color: $bdt-black;\n  border-radius: 4px;\n  transform: translateY(0%);\n  background-color: $bdt-gold;\n  border: solid 1px #01e0572d;\n  transition: all 0.5s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.buy-button:hover .buy-now {\n  transform: translateY(80%);\n}\n\n.buy-now svg path,\n.buy-now svg line {\n  animation: docs 1s infinite;\n}\n\n@keyframes docs {\n  0% {\n    transform: translateY(0%);\n  }\n\n  50% {\n    transform: translateY(-15%);\n  }\n\n  100% {\n    transform: translateY(0%);\n  }\n}\n\n/* Checkbox */\n\n.tabs {\n  display: flex;\n  position: relative;\n  padding: 0.45rem;\n  border-radius: 99px;\n  color: $bdt-gold;\n}\n\n.tabs * {\n  z-index: 2;\n}\n\n.container input[type=\"radio\"] {\n  display: none;\n}\n\n.tab {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30px;\n  width: 50px;\n  font-size: 0.8rem;\n  color: $bdt-white;\n  font-weight: 500;\n  border-radius: 99px;\n  cursor: pointer;\n  transition: color 0.15s ease-in;\n}\n\n@include screen-sm {\n  .shop {\n    flex-wrap: wrap;\n    height: auto;\n  }\n\n  .overlay-shop-menu {\n    width: 100%;\n    height: auto;\n  }\n\n  #d,\n  #s {\n    top: 10%;\n  }\n\n  #d li,\n  #s li {\n    font-size: 1.5em !important;\n  }\n\n  .shop_store_item_info {\n    gap: 1em;\n  }\n\n  .shop_modals_item {\n    width: 100%;\n  }\n\n  .shop_modals_item_product {\n    width: auto;\n  }\n}\n\n@include screen-md {\n  .shop {\n    flex-wrap: wrap;\n    height: auto;\n  }\n\n  .overlay-shop-menu {\n    width: 100%;\n  }\n\n  #d li,\n  #s li {\n    font-size: 1.5em !important;\n  }\n\n  .shop_modals_item {\n    width: 100%;\n  }\n\n  .shop_modals_item_product {\n    width: auto;\n  }\n}\n\n@include screen-lg {\n  .shop {\n    flex-wrap: nowrap;\n    height: 90em;\n  }\n\n  .shop_store_item_info {\n    gap: 4em;\n  }\n\n  .overlay-shop-menu {\n    width: 50%;\n    height: 50em;\n  }\n\n  #d,\n  #s {\n    top: 20%;\n  }\n\n  #d > li,\n  #s li {\n    font-size: 1.7em !important;\n  }\n\n  .shop_modals_item {\n    width: 35em;\n  }\n\n  .shop_modals_item_product {\n    width: 35em;\n  }\n}\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
